//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@components
const RequestMortgageTable = require('./requestMortgageTable');
// @const
const keyPrefix = 'calculateQuotaFixedMortgageTable-calculateQuotaFixedMortgageTable_';

const FixedMortgageTable = props => {
    const {
        isMortgageTableEnabled,
        noConditions,
        showBuildedTable,
    } = props;
    const keySufix = noConditions ? 'NoConditions' : '';

    const cellsHeaderConfiguration = [
        <span>&nbsp;</span>,
        <FormattedText value={`${keyPrefix}header5To15Years`}/>,
        <FormattedText value={`${keyPrefix}header16To20Years`}/>,
        <FormattedText value={`${keyPrefix}header21To25Years`}/>,
        <FormattedText value={`${keyPrefix}header2630Years`}/>,
    ]

    const bodyValues = [
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp50',
            '50In5To15Years',
            '50In16To20Years',
            '50In21To25Years',
            '50In26To30Years'
        ],
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp70',
            '70In5To15Years',
            '70In16To20Years',
            '70In21To25Years',
            '70In26To30Years'
        ],
        [
            'calculateQuotaHeader-calculateQuotaHeader_financeUp80',
            '80In5To15Years',
            '80In16To20Years',
            '80In21To25Years',
            '80In26To30Years'
        ]
    ];

    const cellsBodyConfiguration = bodyValues.map((row) => row.map((cell, index) => ({
        asHeader: false,
        className: index === 0 ? 'mortgage-request-header-calculate-quota__table-container-fixed__body__row__financial-percent' :
            `mortgage-request-header-calculate-quota__table-container-fixed__body__row__value
            mortgage-request-header-calculate-quota__table-container-fixed__body__row__value--small-font-size`,
        value: <FormattedText value={index === 0 ? cell : `${keyPrefix}${cell}${keySufix}`}/>
    })));

    return (
        <RequestMortgageTable
            cellsBodyConfiguration={cellsBodyConfiguration}
            cellsHeaderConfiguration={cellsHeaderConfiguration}
            isMortgageTableEnabled={isMortgageTableEnabled}
            noConditions={noConditions}
            showBuildedTable={showBuildedTable}
            type='fixed'
        ></RequestMortgageTable>
    )
}

FixedMortgageTable.propTypes = {
    isMortgageTableEnabled: PropTypes.bool.isRequired,
    noConditions: PropTypes.bool.isRequired,
    showBuildedTable: PropTypes.bool.isRequired,
}

FixedMortgageTable.defaultProps = {
    showBuildedTable: false
}

module.exports = FixedMortgageTable;
